<template>
	<b-badge class="erco-status-badge" :variant="badgeVariant">{{ uppercasedStatus }}</b-badge>
</template>

<script>
export default {
	name: 'ErcoStatusBadgeAtom',

	data() {
		return {};
	},

	props: {
		status: {
			type: String,
			required: true,
		},
	},
	computed: {
		uppercasedStatus() {
			const status = this.status;

			if (!status) {
				return status;
			}

			return `${status[0].toUpperCase()}${status.substr(1)}`;
		},
		badgeVariant() {
			switch (this.status) {
				case 'online':
					return 'success';
				case 'entwurf':
					return 'primary';
				case 'preview':
					return 'primary';
				default:
					return 'info';
			}
		},
	},
};
</script>

<style lang="scss">
	.erco-status-badge {

	}
</style>



// WEBPACK FOOTER //
// ErcoStatusBadge.vue?017ad102